import React from "react";

const Card = ({ title, children, className = "", headerActions = null }) => {
  return (
    <div className={`card ${className}`}>
      {title && (
        <div className="card-header">
          <div className="card-header-content">
            <h3 className="card-title">{title}</h3>
            {headerActions && (
              <div className="card-header-actions">{headerActions}</div>
            )}
          </div>
        </div>
      )}
      <div className={title ? "card-body-with-header" : "card-body"}>
        {children}
      </div>
    </div>
  );
};

export default Card;
